import { Component, ViewEncapsulation, AfterViewInit, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from "@angular/router";
import { FormGroup, FormBuilder } from '@angular/forms';
import { ToastrService } from "ngx-toastr";

import * as is from 'is';

import { ProjectService } from '@service/project.service';
import { TextStructureCycle } from '@model/TextStructureCycle';
import { Message } from '@model/Message';

@Component({
  selector: 'app-text-structure-cycle',
  templateUrl: './text-structure-cycle.component.html',
  styleUrls: ['./text-structure-cycle.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TextStructureCycleComponent implements OnInit, AfterViewInit {

  public formCyclesConfig: FormGroup;
  public textualFormSubmitted: boolean = false;
  private projectId: number;

  constructor(
    private ar: ActivatedRoute,
    private router: Router,
    private toast: ToastrService,
    private fb: FormBuilder,
    private projectService: ProjectService
  ) {}

  ngOnInit() {
    const id = this.ar.snapshot.paramMap.get('id');

    if (is.null(id)) {
      this.toast.error('O projeto informado não foi encontrado, tente novamente!');
      this.router.navigate(['/']);
    }

    this.projectId = +id;

    this.formCyclesConfig = this.fb.group({
      show_planning_step_one: [false, []],
      show_planning_step_two_search_strategy: [false, []],
      show_planning_step_two_keywords: [false, []],
      show_planning_step_two_research_questions: [false, []],
      show_planning_step_two_objectives: [false, []],
      show_planning_step_two_justification: [false, []],
      show_planning_step_two_hypotheses: [false, []],
      show_planning_step_two_selection_criteria: [false, []],
      show_planning_step_three: [false, []],
      show_planning_step_four: [false, []],
      show_development_step_five: [false, []],
      show_development_step_six: [false, []],
      show_development_step_seven: [false, []],
    });

    const textStructureCycle = ProjectService.text_structure_cycle;
    if (textStructureCycle) {
      this.formCyclesConfig.patchValue({
        show_planning_step_one: textStructureCycle.show_planning_step_one,
        show_planning_step_two_search_strategy: textStructureCycle.show_planning_step_two_search_strategy,
        show_planning_step_two_keywords: textStructureCycle.show_planning_step_two_keywords,
        show_planning_step_two_research_questions: textStructureCycle.show_planning_step_two_research_questions,
        show_planning_step_two_objectives: textStructureCycle.show_planning_step_two_objectives,
        show_planning_step_two_justification: textStructureCycle.show_planning_step_two_justification,
        show_planning_step_two_hypotheses: textStructureCycle.show_planning_step_two_hypotheses,
        show_planning_step_two_selection_criteria: textStructureCycle.show_planning_step_two_selection_criteria,
        show_planning_step_three: textStructureCycle.show_planning_step_three,
        show_planning_step_four: textStructureCycle.show_planning_step_four,
        show_development_step_five: textStructureCycle.show_development_step_five,
        show_development_step_six: textStructureCycle.show_development_step_six,
        show_development_step_seven: textStructureCycle.show_development_step_seven
      });
    }
  }

  ngAfterViewInit() {}

  checkAll(e, $ref:any, form:any | FormGroup) {
    if (e.currentTarget.checked) {
      $($ref).find('input[type="checkbox"]').prop('checked', true);
      for (const field in form.controls) {
        const control = form.controls[field];
        if(control.value === false) {
          control.setValue(true);
        }
      }
    } else {
      $($ref).find('input[type="checkbox"]').prop('checked', false);
      for (const field in form.controls) {
        const control = form.controls[field];
        if (control.value === true) {
          control.setValue(false);
        }
      }
    }
  }

  saveCyclesConfig(): void {
    this.textualFormSubmitted = true;

    if (this.formCyclesConfig.invalid) {
      return;
    }

    const formData: any = this.formCyclesConfig.value;

    const data: TextStructureCycle = {
      project_id: this.projectId,
      ...formData
    };

    const textStructureCycle = ProjectService.text_structure_cycle;
    if (textStructureCycle) {
      this.projectService.updateCycleStructure(data, textStructureCycle.id)
      .subscribe(() => {
        this.updateTemplateStorage(data);
        this.textualFormSubmitted = false;
        this.toast.success(Message.SUCCESS);
      }, this.errorHandler);
    } else {
      this.projectService.storeCycleStructure(data)
      .subscribe((textStructureCycle: TextStructureCycle) => {
        this.updateTemplateStorage({ ...data, id: textStructureCycle.id });
        this.textualFormSubmitted = false;
        this.toast.success(Message.SUCCESS);
      }, this.errorHandler);
    }

    localStorage.setItem('show_development_step_six', `${formData.show_development_step_six}`)
    localStorage.setItem('show_development_step_five', `${formData.show_development_step_five}`)
  }

  private updateTemplateStorage(text_structure_cycles: TextStructureCycle) {
    ProjectService.text_structure_cycles = {...ProjectService.text_structure_cycle, ...text_structure_cycles};
  }

  private errorHandler = (e: HttpErrorResponse) => {
    for (const key in e.error.errors) {
      this.toast.error(e.error.errors[key]);
    }
  }
}
